export default __webpack_public_path__ + "6d543997ea74936ec4ee6ee4c883051e.png";